import type { ORPCClient } from '@/lib/orpc'
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle
} from '@/components/ui/item'
import { Skeleton } from '@/components/ui/skeleton'
import { useSuspenseQuery } from '@tanstack/react-query'
import { Key } from 'lucide-react'

import ApiKeyItem from './api-key-item'

export function ApiKeysView({ orpc }: { orpc: ORPCClient }) {
  const { data: apiKeys } = useSuspenseQuery(
    orpc.backoffice.apiKeys.getAll.queryOptions()
  )

  return (
    <div className="flex w-full flex-col overflow-x-hidden py-8">
      <div className="mb-8 flex flex-col px-6">
        <h1 className="mb-4 text-xl font-semibold md:text-2xl">API Keys</h1>
        <p className="text-muted-foreground max-w-5xl">
          Jangan lupa untuk menjaga keamanannya, jangan pernah membagikannya
          kepada orang lain dan buat ulang jika terjadi kebocoran.
        </p>
      </div>
      <div className="grid max-w-5xl grid-cols-1 gap-6 px-6 md:grid-cols-2">
        {apiKeys.map((apiKey) => (
          <ApiKeyItem key={apiKey.id} apiKey={apiKey} orpc={orpc} />
        ))}
      </div>
    </div>
  )
}

export function ApiKeysPendingView() {
  return (
    <div className="flex w-full flex-col overflow-x-hidden py-8">
      <div className="mb-8 flex flex-col px-6">
        <h1 className="mb-4 text-xl font-semibold md:text-2xl">
          Manajemen API Keys
        </h1>
        <p className="text-muted-foreground max-w-5xl">
          Jangan lupa untuk menjaga keamanannya, jangan pernah membagikannya
          kepada orang lain dan buat ulang jika terjadi kebocoran.
        </p>
      </div>
      <div className="grid max-w-5xl grid-cols-1 gap-6 px-6 md:grid-cols-2">
        {Array.from({ length: 8 }).map((_, i) => (
          <Item key={i} variant="outline">
            <ItemMedia>
              <Key className="text-muted-foreground/50" />
            </ItemMedia>
            <ItemContent>
              <ItemTitle>
                <Skeleton className="h-5 w-40" />
              </ItemTitle>
              <ItemDescription>
                <Skeleton className="h-4 w-56" />
              </ItemDescription>
            </ItemContent>
            <ItemActions>
              <Skeleton className="h-9 w-9 rounded-md" />
            </ItemActions>
          </Item>
        ))}
      </div>
    </div>
  )
}
